import i18n from "@app/app/I18n";
import { getStatusTypeLabel } from "@app/features/app/constants/AppConstants";

/**
 * DURUM SABİTLERİ + AÇILIŞ İPUCU — burada ARTIK DEPO YOK.
 *
 * TEK-DEPO GÖÇÜ (22 Eyl 2026): bu dosya eskiden `PresenceStore` adlı bir mobx
 * deposu ihraç ediyordu ve aynı veriyi iki yerde tutuyordu:
 *   • `statuses` / `customStatuses` → zengin `presence/state/Presence`in ikizi.
 *     İki okuyucu aynı kişi için farklı cevap verebiliyordu (DM karşılama
 *     avatarı gri "çevrimdışı", hemen üstündeki başlık "Çevrimiçi").
 *   • `myStatus` → kullanıcının seçtiği durum; `user/state/UserSettings.status`
 *     ile ikizdi. Üstelik ws-client açılışta `setLocalPresenceUserSettings`i
 *     İKİNCİ kez çağırıp LocalPresence'ın ayar yüzeyini bu aynaya çeviriyordu →
 *     "tek alana iki yazar": başka cihazdan gelen USER_SETTINGS_UPDATE ayar
 *     deposunu güncelliyor ama sol-alt panel eski localStorage değerini
 *     gösteriyordu.
 * Her iki ikiz de söküldü. Canlı durum `Presence`, kendi seçtiğin durum
 * `UserSettings`tir.
 *
 * Geriye kalan iki şey depo DEĞİL:
 *   1) `statusConfig` / `UserStatus` — 14 bileşenin okuduğu saf sabitler.
 *   2) Açılış ipucu — IDENTIFY(op2) READY'den ve dolayısıyla `UserSettings`
 *      hidrasyonundan ÖNCE gider; o an sunucudan gelmiş bir durum yoktur.
 *      Görünmez bir kullanıcının ilk ~200 ms boyunca çevrimiçi görünmemesi için
 *      son bilinen durum localStorage'da tutulur. Canlı veri değil, önbellek.
 */

export type UserStatus = "online" | "idle" | "dnd" | "invisible" | "offline";

// `label` getter olarak tanımlı: kaynak-referans `getStatusTypeLabel` (AppConstants.ts,
// zaten kaynak-referans 1-1 portlu) her erişimde çağrılır → değer `@app/app/I18n`'in
// reaktif proxy'si üzerinden okunur, mobx observer içinde dil değişince
// otomatik yeniden render eder. Dış API (statusConfig[status].label: string)
// AYNI kalır — 14 tüketici dosyaya (StatusDot, NowActivePanel, vb.) dokunmaya
// gerek yok.
export const statusConfig: Record<UserStatus, { color: string; label: string }> = {
  online: {
    color: "#23d18b",
    get label() {
      return getStatusTypeLabel(i18n, "online");
    },
  },
  idle: {
    color: "#f0b232",
    get label() {
      return getStatusTypeLabel(i18n, "idle");
    },
  },
  dnd: {
    color: "#f04747",
    get label() {
      return getStatusTypeLabel(i18n, "dnd");
    },
  },
  invisible: {
    color: "#747f8d",
    get label() {
      return getStatusTypeLabel(i18n, "invisible");
    },
  },
  offline: {
    color: "#747f8d",
    get label() {
      return getStatusTypeLabel(i18n, "offline");
    },
  },
};

const STORAGE_KEY = "tebhos_presence_status";
const VALID_STATUSES: ReadonlySet<UserStatus> = new Set<UserStatus>([
  "online",
  "idle",
  "dnd",
  "invisible",
  "offline",
]);

/** IDENTIFY(op2) için son bilinen durum — yoksa "online". */
export function loadBootStatusHint(): UserStatus {
  if (typeof window === "undefined") return "online";
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw && VALID_STATUSES.has(raw as UserStatus)) return raw as UserStatus;
  } catch {
    // localStorage erişimi kısıtlı — varsayılana düş.
  }
  return "online";
}

/** Açılış ipucunu tazeler (yazan: LocalPresenceBroadcast, etkin durum değiştikçe). */
export function saveBootStatusHint(status: string): void {
  if (typeof window === "undefined") return;
  if (!VALID_STATUSES.has(status as UserStatus)) return;
  try {
    localStorage.setItem(STORAGE_KEY, status);
  } catch {
    // Kota dolu / kısıtlı — ipucu kozmetiktir, sessizce geç.
  }
}
